<div id="{{ page?.slug }}" class="contentWrapper">
  <div class="container">
    <h1>{{ page?.title }}<div></div></h1>
    <div [innerHtml]="page?.content"></div>
  </div>
</div>